import api from '../api';
import { defaultFetchListOptions } from './useQuery';
import type { FetchListOptions, Group } from '../types/types';

export const useFetchGroups = () => {
  const fetchGroupsByIds = async (ids: string[], itemsPerPage = 10): Promise<Group[]> => {
    const response = await api.fetchers.fetchGroups({
      ...defaultFetchListOptions,
      itemsPerPage,
      filters: {
        uids: ids,
      },
    } as FetchListOptions);
    return response.data.data;
  };

  return {
    fetchGroupsByIds,
  };
};
